import React from 'react';
import { Link, withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import Paginations from '../../common/paginations';
import constant from '../../../constant';

const EventList = ({ data, setCurrentPage, limit, onChangeVisibility }) => {
    const { planTypes, total, page } = data;

    return (
        <>
            <div className="table-responsive">
                <table className="table align-middle table-hover">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Plan Type</th>
                            <th>Status</th>
                            <th>Modified By</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {planTypes?.length > 0 ? (
                            planTypes.map((item, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="avatar-xs">
                                            <span className="avatar-title rounded-circle bg-light text-primary">
                                                {item.PLAN_TYPE?.charAt(0).toUpperCase()}
                                            </span>
                                        </div>
                                    </td>
                                    <td>{item.PLAN_TYPE}</td>
                                   
                                    <td>
                                        <span
                                            className={`badge rounded-pill ${item.IS_ACTIVE ? 'bg-success' : 'bg-secondary'}`}
                                        >
                                            {item.IS_ACTIVE ? 'Active' : 'Inactive'}
                                        </span>
                                    </td>
                                    <td>{item.MODIFIED_BY_NAME || '-'}</td>
                                    <td>
                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                            <li className="list-inline-item px-2">
                                                <Link
                                                    to={{
                                                        pathname: constant.Authedcomponent.editPlanTypeMasterData.url,
                                                        state: {
                                                            data: btoa(JSON.stringify(item)),
                                                            page: page,
                                                        },
                                                    }}
                                                    title="Edit Plan Type"
                                                >
                                                    <i className="bx bx-edit"></i>
                                                </Link>
                                            </li>
                                            <li className="list-inline-item px-2">
                                                <a
                                                    href="javascript:void(0);"
                                                    onClick={() => onChangeVisibility(item)}
                                                    style={{ color: "red" }}
                                                    title={item.IS_ACTIVE ? "Delete Event" : "Restore Event"}
                                                >
                                                    <i className={`bx ${item.IS_ACTIVE ? 'bx-trash' : 'bx-undo'}`} />
                                                </a>
                                            </li>
                                        </ul>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="7" className="text-center">No Events found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <Paginations
                limit={limit}
                totalCount={total}
                range={5}
                currentPage={page}
                onPageChange={setCurrentPage}
            />
        </>
    );
};

export default withRouter(EventList);
